import VerificationLayout from "../VerificationMethodLayout";

const DomainTxtRecordVerification = () => {
  return <VerificationLayout verifyType="Domain TXT Record">DomainTxtRecordVerification</VerificationLayout>;
};

export default DomainTxtRecordVerification;
